import web from "~/modules/web/routes";

export default [...web];
